import React, { useMemo, Fragment } from 'react'
import BulkActionBar from '../../../bulk-action-bar/bulk-action-bar'
import styles from './groups-bulk-action.styles'
import injectSheet from 'react-jss'
import CloseIcon from 'react-icons/lib/fa/close'
import EyeIcon from 'react-icons/lib/fa/eye'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const GroupsBulkAction = ({
  classes,
  selectedGroups,
  deleteGroup,
  showSelected,
  showAll,
  showingSelected,
  onSetVisibility,
  groups
}) => {
  const anyWondeGroupSelected = useMemo(
    () => {
      let result = false
      for (let groupId of selectedGroups) {
        if (groups[groupId].mis_group) {
          result = true
          break
        }
      }
      return result
    },
    [groups, selectedGroups]
  )

  return (
    <BulkActionBar
      onShowAll={showAll}
      onShowSelected={showSelected}
      show={selectedGroups.length}
      selected={selectedGroups}
      showingSelected={showingSelected}
      renderMessage={selected => `${selected.length} groups selected`}
      renderContextMenu={({
        Menu,
        MenuItem,
        IconHolder,
        Separator,
        closePopover
      }) => (
        <Menu>
          <MenuItem onClick={() => closePopover() && onSetVisibility()}>
            <IconHolder>
              <EyeIcon />
            </IconHolder>
            Set visibility
          </MenuItem>
          {!anyWondeGroupSelected && (
            <Fragment>
              <Separator />
              <MenuItem
                className={classes.deleteGroup}
                onClick={() =>
                  closePopover() &&
                  openConfirmationDialog({
                    bodyText: `Are you sure you want to delete ${
                      selectedGroups.length
                    } groups?`,
                    confirmText: 'Delete groups',
                    action: deleteGroup
                  })
                }>
                <IconHolder>
                  <CloseIcon />
                </IconHolder>
                Delete groups
              </MenuItem>
            </Fragment>
          )}
        </Menu>
      )}
    />
  )
}

export default injectSheet(styles)(GroupsBulkAction)
